// "Read the note" — the Charges page's needs-a-person bucket, mounted as one line.
//
// A draft is in that bucket because a person has to decide something, and the
// note is what they decide from. The row already knows whether the visit has a
// note (`sourceNotePresent`, from charge capture), so this offers the reading
// rather than making the biller open the draft and go looking.
//
// It navigates; it does not fetch. The note itself is loaded, audited and gated
// by NotesPane inside the editor.

import React from "react";
import { openClaimEditor } from "../claims/claimEditorTarget";
import { setNotesTarget } from "./notesTarget";

export default function ReadNoteButton({
  practiceId,
  claimId,
  notePresent,
  features = {},
  readOnly = false,
  onPageChange,
}) {
  // Same three conditions the pane itself applies, plus the two this button
  // needs to be useful: somewhere to navigate to, and a note to read.
  if (readOnly || features.note_viewer !== true || features.claim_editor !== true)
    return null;
  if (!onPageChange || !claimId || notePresent === false) return null;

  return (
    <button
      type="button"
      className="btn btn-secondary btn-sm"
      onClick={() => {
        setNotesTarget(claimId);
        openClaimEditor(claimId, onPageChange, practiceId);
      }}
    >
      Read the note
    </button>
  );
}
